export default "__VITE_ASSET__YG69afCi__"